// extracted by mini-css-extract-plugin
export default {"wrapper":"DrawerList_wrapper__Jt5xq"};